import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Old `/parent/all/*` links (bookmarks, pushes sent before this release) land on the new homes. */
const LegacyAllRedirect: React.FC = () => {
  const { pathname, search } = useLocation();
  const tail = pathname.replace(/^\/parent\/all\/?/, '');
  if (tail.startsWith('messages')) return <Navigate to={{ pathname: '/parent/family/inbox', search }} replace />;
  if (tail.startsWith('policies')) return <Navigate to={{ pathname: '/parent/family/policies', search }} replace />;
  return <Navigate to="/parent" replace />;
};
export default LegacyAllRedirect;
